module.exports = __webpack_public_path__ + "img/67.46ad7948.jpg";